<template>
  <div id="admin">
    <menu-admin/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center">
              <i class="fa fa-publication"></i>
              <span v-show="publication.name">{{publication.name}}</span>
              <span v-show="!publication.name">Nova Publicação</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <section class="int-form">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <form>
              <div v-show="publication.id!==null" class="card-details" style="margin-bottom: 0; padding-bottom: 0">
                <a class="badge badge-danger pull-right" href="#"  @click="destroyPublication(publication.id)"  style="color: white !important; margin-top: 4px">
                  <i class="fa fa-times" aria-hidden="true"></i> Remover
                </a>
                <a class="badge badge-info" href="#" @click="redirectURL('/admin/report/publication_clients/'+publication.id)" style="color: white !important;">
                  <i class="fa fa-list" aria-hidden="true"></i> Usuários da Publicação
                </a>
              </div>

              <div class="card-details">
                <h3 class="title">Detalhes da publicação</h3>
                <div class="row">
                  <div class="form-group col-sm-4">
                    <label for="is_signature">Com assinatura?</label>
                    <select id="is_signature" class="form-control" v-model="publication.is_signature">
                      <option v-bind:value="true">Sim</option>
                      <option v-bind:value="false">Não</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-4">
                    <label for="is_download">Com download?</label>
                    <select id="is_download" class="form-control" v-model="publication.is_download">
                      <option v-bind:value="true">Sim</option>
                      <option v-bind:value="false">Não</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-4" v-show="!publication.is_download">
                    <label for="is_sent_immediately">É enviado imediatamente?</label>
                    <select id="is_sent_immediately" class="form-control" v-model="publication.is_sent_immediately">
                      <option v-bind:value="true">Sim</option>
                      <option v-bind:value="false">Não</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-4" v-show="publication.is_download">
                    &nbsp;
                  </div>
                  <div class="form-group col-sm-4">
                    <label for="has_airplane_info">Solicita Dados do avião?</label>
                    <select id="has_airplane_info" class="form-control" v-model="publication.has_airplane_info">
                      <option v-bind:value="true">Sim</option>
                      <option v-bind:value="false">Não</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-4">
                    <label for="has_photo_upload">Solicita Envio de imagem?</label>
                    <select id="has_photo_upload" class="form-control" v-model="publication.has_photo_upload">
                      <option v-bind:value="true">Sim</option>
                      <option v-bind:value="false">Não</option>
                    </select>
                    <span class="errorForm"></span>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="form-group col-sm-6">
                    <label for="name">Nome</label>
                    <input id="name" type="text" v-model="publication.name" class="form-control" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="version">Revisao</label>
                    <input id="version" type="text" v-model="publication.version" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="date">Data</label>
                    <input id="date" type="text" v-mask="'##/##/####'" class="form-control" v-model="date" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="weight">Peso (Kg)</label>
                    <input id="weight" type="text" class="form-control" v-money="money" v-model.lazy="weight" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="price">Preço</label>
                    <input id="price" type="text" v-model.lazy="price" v-money="money" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="price">Preço de Assinatura</label>
                    <input id="price_signature" type="text" v-model.lazy="price_signature" v-money="money" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                  <div class="form-group col-sm-12">
                    <label for="applicability">Aplicabilidade</label>
                    <input id="applicability" type="text" v-model="publication.applicability" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                    <span class="errorForm"></span>
                  </div>
                </div>
                <div v-show="publication.id != null">
                  <hr/>
                  <div class="row">
                    <div class="form-group col-sm-12">

                      <div style="margin-bottom: 20px;" v-show="uploadPercentage > 0" class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>

                      <file-select v-model="file"></file-select>

                      <span v-show="publication.file" style="margin-top: 17px" class="pull-right">
                        <i class="fa fa-file-text-o fa-lg"></i>
                        <a target="_blank" v-bind:href="publication.file"> Abrir arquivo cadastrado</a>
                      </span>
                      <span class="errorForm"></span>
                    </div>
                  </div>
                </div>

              </div>
              <hr/>
              <div class="card-details" style="padding-top: 0">
                <div class="row">
                  <div class="form-group col-sm-12">
                    <div id="sucessUpdate" class="alert alert-success text-center" role="alert" style="display: none;">As informações foram salvas com sucesso</div>
                    <div id="errorFound" class="alert alert-danger text-center" role="alert" style="display: none">Um erro foi encontrado. Verifique os campos do formulário</div>
                    <button type="button" class="btn btn-secondary" onclick="window.history.back()">Voltar</button>
                    <button type="button" class="btn btn-primary pull-right" @click="savepublication()">Salvar</button>
                    <div class="alert alert-light text-right" ><label style="text-transform: none !important;"> Enviar e-mail de notificação para todos os assinantes <input id="send_notifications" type="checkbox"></label> </div>

                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <footer-admin/>
  </div>
</template>

<script>
  import publication from "../../api/publication"
  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import { mapState } from 'vuex'
  import mixins from "../../helpers/mixins"
  import {VMoney} from 'v-money'
  import FileSelect from './FileSelect.vue'
  import axios from 'axios'
  import { CONFIGS } from '../../configs'

  export default {
    name: "AdminPublicationsView",
    mixins: [mixins],
    data () {
      return {
        publication: { id: null },
        price: 0,
        price_signature: 0,
        weight: 0,
        date: null,
        file: null,
        value: null,
        uploadPercentage: 0,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false /* doesn't work with directive */
        }
      }
    },
    components: { menuAdmin, footerAdmin, FileSelect },
    computed: {
      ...mapState(['logged'])
    },
    directives: { money: VMoney },
    methods: {
      uploadFile(){
        if(this.file){
          let formData = new FormData();
          formData.append("file", this.file);
          let publication = this.publication
          axios.put(CONFIGS.API_SERVER + '/api/upload/'+ this.publication.id +'/', formData, {
              headers: {'Content-Type': 'multipart/form-data'},
              onUploadProgress: function( progressEvent ) {
                this.uploadPercentage = parseInt(Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ));
                let percent = this.uploadPercentage+'%'
                $('.progress-bar').css({'width': percent}).html(percent)
                if(this.uploadPercentage === 100) $('.progress-bar').html('Arquivo enviado')
              }.bind(this)
            }).then(function (response) {
              if(response.status === 200){
                publication.file = response.data.file
              }
            })
        }
        return true
      },
      getpublication(id){
          publication.get(id).then((response)  =>  {
            this.publication = response.data
            this.price = this.publication.price
            this.price_signature = this.publication.price_signature
            this.weight = this.publication.weight
            this.date = this.formatDate(this.publication.date, 'pt-br')
          })
      },
      destroyPublication(id){
          publication.remove(id).then((response)  =>  {
            if(response.status === 204) {
              alert('Publicação removida com sucesso!')
              this.$router.push({name: 'admin_publications'})
            }
          })
      },
      savepublication(){
          $("#sucessUpdate").hide()

          this.publication.price = parseFloat(this.price.replace(/\./g,'').replace(",", "."))
          this.publication.price_signature = parseFloat(this.price_signature.replace(/\./g,'').replace(",", "."))
          this.publication.weight = parseFloat(this.weight.replace(/\./g,'').replace(",", "."))
          this.publication.date = this.formatDate(this.date)
          let data = this.publication

          if(data.id>0) {
            data.notify = false

            if($('#send_notifications').prop('checked')){
              if(confirm("Enviar e-mail de notificação aos usuários?") === true){
                  data.notify = true
              }
            }

            publication.update(data, data.id).then((response) => {
                if(response.status === 200){
                  $("#sucessUpdate").show()
                } else {
                  alert('ATENÇÃO: Não foi possivel atualizar a publicação!');
                }
              }).catch(errors => { this.formErrors(errors) })
          } else {
            publication.create(this.publication).then((response) => {
                if(response.status === 201){
                  $("#sucessUpdate").show()
                  this.getpublication(response.data.id)
                } else {
                  alert('ATENÇÃO: Não foi possivel salvar a publicação!');
                }
              }).catch(errors => { this.formErrors(errors) })
          }
      }
    },
    mounted(){
      if(this.$route.params.id !== undefined && this.$route.params.id > 0)
        this.getpublication(this.$route.params.id)
    }
  }
</script>
